import { ROUTE_PERMISSIONS, STATUS_TYPES } from '../core/constants';
import Rest, { isApiErrorDetailInclude } from "../core/rest";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getReduxActionErrorMessage, isReduxThunkRejectedAction } from '../core/utils';
import { hasAccess, hasSuperAdminAccess } from "src/core/PermissionHandler";

import { ApiGatewayUrl } from "../appsettings";
import ErrorException from "src/components/ErrorException";
import _ from "lodash";

const SLICE_NAME = "preset";

export const getPresets = createAsyncThunk(
  "preset/getPresets",
  async (name) => {
    try {
      const response = await Rest.get(ApiGatewayUrl + "/presets?name=" + name);

      return { data: response.data, filter: name };
    } catch (ex) {
      ErrorException(ex.response);
    }
  });

export const savePreset = createAsyncThunk(
  "preset/savePreset",
  async (preset) => {
    try {
      let response = await Rest.post(ApiGatewayUrl + "/presets", preset);
      return response.data;
    } catch (ex) {
      ErrorException(ex.response);
    }
  }
);

export const renamePreset = createAsyncThunk(
  "preset/renamePreset",
  async (preset) => {
    try {
      let response = await Rest.put(ApiGatewayUrl + "/presets/rename", preset);
      return response.data;
    } catch (ex) {
      ErrorException(ex.response);
    }
  }
);
export const sharePreset = createAsyncThunk(
  "preset/sharePreset",
  async (preset) => {
    try {
      let response = await Rest.put(ApiGatewayUrl + "/presets/share", preset);
      return response.data;
    } catch (ex) {
      ErrorException(ex.response);
    }
  }
);
export const editPreset = createAsyncThunk(
  "preset/editPreset",
  async (preset) => {
    try {
      let response = await Rest.put(ApiGatewayUrl + "/presets/edit", preset);
      return response.data;
    } catch (ex) {
      ErrorException(ex.response);
    }
  }
);
export const approveSharePreset = createAsyncThunk(
  "preset/approveSharePreset",
  async (id) => {
    try {
      let response = await Rest.put(ApiGatewayUrl + "/presets/approve?id=" + id);
      return response.data;
    } catch (ex) {
      ErrorException(ex.response);
    }
  }
);
export const deletePreset = createAsyncThunk(
  "preset/deletePreset",
  async (pname, { rejectWithValue }) => {
    try {
      await Rest.delete(ApiGatewayUrl + "/presets/" + pname);
    } catch (ex) {
      if (isApiErrorDetailInclude(ex)) {
        return rejectWithValue(ex.response.data);
      }
      throw ex.response;
    }
  }
);
export const presetSlice = createSlice({
  name: SLICE_NAME,
  initialState: {
    isLoading: false,
    ownPresets: [],
    sharedPresets: [],
    pendingPresets: [],
    errorMessage: '',
    filterText: '', 
    isExpand: false
  },
 reducers: {
addExpandList: (state, action) => {
    state.expandList= action.payload;
}
 },
  extraReducers: (builder) => {
    builder
      .addCase(getPresets.fulfilled, (state, action) => {
        const isSuperAdmin = hasSuperAdminAccess();
        const hasAgencyAdminAccess = hasAccess(ROUTE_PERMISSIONS.management)
        let ownPresetList = {
          name: "My Presets",
          showShare: isSuperAdmin ? false : true,
          showRename: true,
          showDelete: true,
          isPending: false,
          children: _.map(action.payload.data.ownPresets, (l) => {
            return {
              id: l.id,
              name: l.name,
              layoutData: l.layoutData.split("'").join('"'),
              players: l.players.split("'").join('"'),
              cellCount: l.cellCount,
              userId: l.userId,
              agencyId: l.agencyId,
              type: l.presetType
            };
          })
        }
        let sharedPresetList = _.map(action.payload.data.sharedPresets, (share) => {
          return {
            
            name: share.agencyName + " Presets",
            showShare: false,
            showRename: hasAgencyAdminAccess ? true : false,
            showDelete: hasAgencyAdminAccess ? true : false,
            isPending: false,
            children: _.map(share.presets, (p => {
              return {
                id: p.id,
                name: p.name,
                layoutData: p.layoutData.split("'").join('"'),
                players: p.players.split("'").join('"'),
                cellCount: p.cellCount,
                userId: p.userId,
                agencyId: p.agencyId,
                type: p.presetType
              }
            }))
          }
        }
        );
        let pendingPresetList = {
          name: "Presets Pending Approval",
          showShare: false,
          showRename: false,
          showDelete: false,
          isPending: true,
          children: _.map(action.payload.data.pendingPresets, (l) => {
            return {
              id: l.id,
              name: l.name,
              layoutData: l.layoutData.split("'").join('"'),
              players: l.players.split("'").join('"'),
              cellCount: l.cellCount,
              type: l.presetType
            };
          })
        }
        return {
          ...state,
          isLoading: false,
          ownPresets: ownPresetList,
          sharedPresets: sharedPresetList,
          pendingPresets: pendingPresetList,
          filterText: action.payload.filter,
        };
      })
      .addCase(getPresets.pending, (state) => {
        return{
          ...state,
          isLoading: true
        }
      })

      //handle rejected actions.
      .addMatcher((action) => isReduxThunkRejectedAction(SLICE_NAME, action.type), (state, action) => {
        if (action.error && action.error.message === "Aborted") {
          return {
            ...state,
            isLoading: false,
            statusType: "",
            actionType: action.type?.split("/")[1],
            errorMessage: "",
          };
        } else {
          return {
            ...state,
            isLoading: false,
            actionType: action.type?.split("/")[1],
            statusType: STATUS_TYPES.rejected,
            errorMessage: getReduxActionErrorMessage(action)
          };
        }
      })
  },
});

export const presetActions = presetSlice.actions;
export const presetState = (state) => state.preset;
export default presetSlice.reducer;

